import { render, staticRenderFns } from "./FooterTip.vue?vue&type=template&id=e89a74a6&scoped=true"
import script from "./FooterTip.vue?vue&type=script&lang=js"
export * from "./FooterTip.vue?vue&type=script&lang=js"
import style0 from "./FooterTip.vue?vue&type=style&index=0&id=e89a74a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89a74a6",
  null
  
)

export default component.exports